



// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchSearchHistory, fetchReverseSearchHistory, setSelectedUser, fetchPremiumDetails } from '../../redux/search/SearchSlice';

// import PaystackPop from '@paystack/inline-js';
// import axios from 'axios';

// const SearchDashboard = () => {
//   const dispatch = useDispatch();
//   const { searchHistory, reverseSearchHistory, selectedUser, premiumDetails, loading, error } = useSelector((state) => state.search);
//   const { currentUser } = useSelector((state) => state.user);

//   useEffect(() => {
//     dispatch(fetchSearchHistory());
//     dispatch(fetchReverseSearchHistory());
//   }, [dispatch]);

//   const handleViewDetails = (user) => {
//     dispatch(setSelectedUser(user));
//   };

//   const handlePayForPremium = async (userId) => {
//     const paystack = new PaystackPop();
//     paystack.newTransaction({
//       key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY, 
//       email: currentUser.email,
//       amount: 300000, // ₦3000 in kobo
//       onSuccess: async (transaction) => {
//         try {
//           await axios.post(`${process.env.REACT_APP_API_URL}payment/verify`, { reference: transaction.reference, userId }, {
//             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//           });
//           dispatch(fetchPremiumDetails(userId));
//         } catch (error) {
//           console.error('Payment verification failed:', error);
//         }
//       },
//       onCancel: () => {
//         console.log('Payment cancelled');
//       },
//     });
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl">Search History</h2>
//       <h3 className="mt-4">Users You Searched For</h3>
//       {error && <p className="text-red-500">{error}</p>}
//       <ul className="list-disc pl-5">
//         {searchHistory.map((entry) => (
//           <li key={entry.user.id}>
//             {entry.user.name} ({entry.user.userType}) - Searched at {new Date(entry.timestamp).toLocaleString()}
//             <button
//               onClick={() => handleViewDetails(entry.user)}
//               className="ml-2 text-blue-500 underline"
//             >
//               View Details
//             </button>
//             {selectedUser?.id === entry.user.id && (
//               <button
//                 onClick={() => handlePayForPremium(entry.user.id)}
//                 className="ml-2 bg-orange-500 text-white p-1 rounded"
//               >
//                 Unlock Premium Details
//               </button>
//             )}
//           </li>
//         ))}
//       </ul>
//       <h3 className="mt-4">Users Who Searched for You</h3>
//       <ul className="list-disc pl-5">
//         {reverseSearchHistory?.map((entry) => (
//           <li key={entry?.user?.id}>
//             {entry?.user.name} ({entry?.user.userType}) - Searched for you at {new Date(entry?.timestamp).toLocaleString()}
//             <button
//               onClick={() => handleViewDetails(entry.user)}
//               className="ml-2 text-blue-500 underline"
//             >
//               View Details
//             </button>
//             {selectedUser?.id === entry?.user.id && (
//               <button
//                 onClick={() => handlePayForPremium(entry?.user.id)}
//                 className="ml-2 bg-orange-500 text-white p-1 rounded"
//               >
//                 Unlock Premium Details
//               </button>
//             )}
//           </li>
//         ))}
//       </ul>
//       {selectedUser && (
//         <div className="mt-4">
//           <h3>Basic Details</h3>
//           <p>Name: {selectedUser.name}</p>
//           <p>User Type: {selectedUser.userType}</p>
//           <p>hiredHistory: {selectedUser.hiredHistory}</p>
//         </div>
//       )}
//       {premiumDetails && selectedUser?.id === premiumDetails.id && (
//         <div className="mt-4">
//           <h3>Premium Details</h3>
//           <p>Email: {premiumDetails.email}</p>
//           <p>Phone: {premiumDetails.phoneNumber}</p>
//           {premiumDetails.userType === 'jobSeeker' && <p>Job Mode: {premiumDetails.jobMode}</p>}
//           {premiumDetails.userType === 'jobEmployer' && <p>Company Size: {premiumDetails.size}</p>}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchDashboard;


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSearchHistory, fetchReverseSearchHistory, setSelectedUser, fetchPremiumDetails } from '../../redux/search/SearchSlice';
import PaystackPop from '@paystack/inline-js';
import axios from 'axios';

const SearchDashboard = () => {
  const dispatch = useDispatch();
  const { searchHistory, reverseSearchHistory, selectedUser, premiumDetails, loading, error } = useSelector((state) => state.search);
  const { currentUser } = useSelector((state) => state.user);

  useEffect(() => {
    if (currentUser?.uniqueNumber) {
      console.log('Fetching search history for user:', currentUser.uniqueNumber);
      dispatch(fetchSearchHistory());
      dispatch(fetchReverseSearchHistory());
    }
  }, [dispatch, currentUser]);

  useEffect(() => {
    console.log('Search History:', searchHistory);
    console.log('Reverse Search History:', reverseSearchHistory);
  }, [searchHistory, reverseSearchHistory]);

  const handleViewDetails = (user) => {
    dispatch(setSelectedUser(user));
  };

  const handlePayForPremium = async (userId) => {
    const paystack = new PaystackPop();
    paystack.newTransaction({
      key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
      email: currentUser.email,
      amount: 300000, // ₦3000 in kobo
      onSuccess: async (transaction) => {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/verify`, { reference: transaction.reference, userId }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });
          if (response.data.success) {
            dispatch(fetchPremiumDetails(userId));
          }
        } catch (error) {
          console.error('Payment verification failed:', error.response?.data?.message || error.message);
        }
      },
      onCancel: () => {
        console.log('Payment cancelled');
      },
    });
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl">Search History</h2>
      {/* {error && <p className="text-red-500">{error}</p>} */}
      {!currentUser && <p className="text-red-500">Please log in to view search history</p>}
      <h3 className="mt-4">Users You Searched For</h3>
      {searchHistory.length === 0 && <p>No searches yet</p>}
      <ul className="list-disc pl-5">
        {searchHistory.map((entry) => (
          entry?.user ? (
            <li key={entry.user.id}>
              {entry.user.name} ({entry.user.userType}) - Searched at {new Date(entry.timestamp).toLocaleString()}
              <button
                onClick={() => handleViewDetails(entry.user)}
                className="ml-2 text-blue-500 underline"
              >
                View Details
              </button>
              {selectedUser?.id === entry.user.id && (
                <button
                  onClick={() => handlePayForPremium(entry.user.id)}
                  className="ml-2 bg-orange-500 text-white p-1 rounded"
                >
                  Unlock Premium Details
                </button>
              )}
            </li>
          ) : null
        ))}
      </ul>
      <h3 className="mt-4">Users Who Searched for You</h3>
      {reverseSearchHistory.length === 0 && <p>No one has searched for you yet</p>}
      <ul className="list-disc pl-5">
        {reverseSearchHistory.map((entry) => (
          entry?.user ? (
            <li key={entry.user.id}>
              {entry.user.name} ({entry.user.userType}) - Searched for you at {new Date(entry.timestamp).toLocaleString()}
              <button
                onClick={() => handleViewDetails(entry.user)}
                className="ml-2 text-blue-500 underline"
              >
                View Details
              </button>
              {selectedUser?.id === entry.user.id && (
                <button
                  onClick={() => handlePayForPremium(entry.user.id)}
                  className="ml-2 bg-orange-500 text-white p-1 rounded"
                >
                  Unlock Premium Details
                </button>
              )}
            </li>
          ) : null
        ))}
      </ul>
      {selectedUser && (
        <div className="mt-4">
          <h3>Basic Details</h3>
          <p>Name: {selectedUser.name}</p>
          <p>User Type: {selectedUser.userType}</p>
        </div>
      )}
      {premiumDetails && selectedUser?.id === premiumDetails.id && (
        <div className="mt-4">
          <h3>Premium Details</h3>
          <p>Email: {premiumDetails.email}</p>
          <p>Phone: {premiumDetails.phoneNumber}</p>
          {premiumDetails.userType === 'jobSeeker' && <p>Job Mode: {premiumDetails.jobMode}</p>}
          {premiumDetails.userType === 'jobEmployer' && <p>Company Size: {premiumDetails.size}</p>}
        </div>
      )}
    </div>
  );
};

export default SearchDashboard;